import {
  ROLE_ADMINISTRATOR,
  ROLE_FINANCE_ADMIN,
} from '@libs/shared/domain/master-data/user/shared-master-data-user-role.type';
import { SharedSettingsDataviewAccessContextSchema } from '@libs/shared/domain/settings/shared-settings-dataview-access-context.schema';
import { SharedSettingsDataviewItemAccessSchema } from '@libs/shared/domain/settings/shared-settings-dataview-item-access.schema';
import { difference as _difference, intersection as _intersection } from 'lodash';

const TENANT_RESTRICTION_EXEMPT_ROLES: string[] = [ROLE_ADMINISTRATOR, ROLE_FINANCE_ADMIN];

export function sharedDataviewHasAccessToItem(
  item: SharedSettingsDataviewItemAccessSchema,
  { role, tenants, hasAllTenantsAccess }: SharedSettingsDataviewAccessContextSchema,
): boolean {
  const userTenants = tenants ?? [];

  const roleHasAccess =
    (!item.roleWhitelist || (!!role && item.roleWhitelist.includes(role))) &&
    (!item.roleBlacklist || (!!role && !item.roleBlacklist.includes(role))) &&
    (!item.tenantWhitelist || hasAllTenantsAccess || _intersection(item.tenantWhitelist, userTenants).length > 0) &&
    (!item.tenantBlacklist || hasAllTenantsAccess || _difference(item.tenantBlacklist, userTenants).length > 0);

  const userHasRelevantTenantsAccess =
    !item.forTenantsWhitelist ||
    (!!role && TENANT_RESTRICTION_EXEMPT_ROLES.includes(role)) ||
    (!!tenants && item.forTenantsWhitelist.every((tenant) => tenants.includes(tenant)));

  return roleHasAccess && userHasRelevantTenantsAccess;
}
